export default {
  APP_FINN_NAME : "Atendimento",
  APP_FINN_EMAIL : "atendimento@finnseguros.com.br",
  APP_FINN_EMAIL_GUARANTEE : "garantia@finnseguros.com.br",
  APP_FINN_TELEPHONE : "11 91569-6804"
}